import { useContext } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { APP_CONTEXT } from '@/utils/context';
import Alert from '@/components/alert/alert-component';
import Modal from '@/components/modal/modal-component';
import CustomerForm from '@/pages/customer-management/customer-form';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import createCustomerApi from '@/api/post/customer/create-customer';
import { Col } from '@/components/grid/grid-component';
import SubmitCard from '@/components/card/submit-card-component';

/**
 * Quick add customer form
 * @file quick-create-customer.jsx
 * @param {boolean} open - open modal
 * @returns {JSX.Element} Quick add customer form
 */
const QuickCreateCustomer = ({ open, onClose }) => {
  const { currentUser } = useContext(APP_CONTEXT);

  return (
    <Modal
      width="calc(100vw - 10px)"
      open={open}
      showClose
      bodyStyle={{
        padding: '0px',
      }}
      close={() => {
        onClose();
      }}
      title="Add Customer"
    >
      <Col xs={12}>
        <FormWrapper
          defaultValues={{
            name: '',
            contact_number: '',
            status: 'active',
            contact_person: [
              {
                id: uuidv4(),
                name: '',
                email: '',
                contact_number: '',
                position: '',
                default_recipient_of_quotes: true,
              },
            ],
            operating_site: [
              {
                name: '',
                country: '',
                nearest_town: '',
                site_commodity: '',
                other: '',
              },
            ],
          }}
          onSubmit={(sValues) => {
            const values = { ...sValues };
            const contactPerson = values.contact_person.map((price) => price);
            const operatingSite = values.operating_site.map((price) => price);

            delete values.contact_person;
            delete values.operating_site;

            const submitValues = {
              customer: {
                ...values,
                is_archived: false,
                added_by_user: currentUser.id,
              },
              contactPerson: { add: contactPerson },
              operatingSite: { add: operatingSite },
            };
            createCustomerApi(submitValues).then(({ data }) => {
              onClose(data?.id);

              Alert({
                icon: 'success',
                text: 'Customer created successfully',
              });
            });
          }}
        >
          <CustomerForm statusDisabled noSpacer />
          <SubmitCard
            padding="0"
            primaryButtonTitle="Save"
            primaryButtonType="submit"
            primaryButtonDisabled={false}
            primaryButtonWidth="112px"
            isLoading={false}
            secondaryButtonTitle="Cancel"
            secondaryButtonType="button"
            secondaryButtonWidth="112px"
            secondaryButtonDisabled={false}
            submitClickSecondary={() => {
              onClose();
            }}
          />
        </FormWrapper>
      </Col>
    </Modal>
  );
};

QuickCreateCustomer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

QuickCreateCustomer.defaultProps = {};

export default QuickCreateCustomer;
